var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.391 17V9.282h2.348V8.15H8.391V6.984c0-1.269.634-1.75 1.64-1.75.298 0 .634.035.969.138v-1.2A5.358 5.358 0 009.733 4c-1.826 0-2.87.96-2.87 2.813V8.15H5v1.132h1.863V17h1.528zm9.734 4c.485 0 .875-.376.875-.844V8.625h-4.958c-.482 0-.875-.38-.875-.844V3H5.875C5.39 3 5 3.376 5 3.844v16.312c0 .468.39.844.875.844h12.25zM19 8v-.238a.936.936 0 00-.273-.66l-3.825-3.829A.938.938 0 0014.238 3H14v5h5z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.99
  })));
}
export default __webpack_public_path__ + "static/media/d9412156a5c0921655bceec7f5183eb7-documents.svg";
export { SvgDocuments as ReactComponent };